/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Is_Community_EnabledInputs */

const en_is_community_enabled = /** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Storefront Community`)
};

const es_is_community_enabled = /** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar Comunidad en la Tienda`)
};

const fr_is_community_enabled = /** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer la communauté de la vitrine`)
};

const de_is_community_enabled = /** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront-Community aktivieren`)
};

const id_is_community_enabled = /** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan Komunitas Etalase`)
};

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const ja_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const zh_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const ar_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const it_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const ru_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const pt_is_community_enabled = en_is_community_enabled;

/** @type {(inputs: Is_Community_EnabledInputs) => LocalizedString} */
const ko_is_community_enabled = en_is_community_enabled;

/**
* | output |
* | --- |
* | "Enable Storefront Community" |
*
* @param {Is_Community_EnabledInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const is_community_enabled = /** @type {((inputs?: Is_Community_EnabledInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Is_Community_EnabledInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_is_community_enabled(inputs)
	if (locale === "es") return es_is_community_enabled(inputs)
	if (locale === "fr") return fr_is_community_enabled(inputs)
	if (locale === "de") return de_is_community_enabled(inputs)
	if (locale === "ja") return ja_is_community_enabled(inputs)
	if (locale === "zh") return zh_is_community_enabled(inputs)
	if (locale === "ar") return ar_is_community_enabled(inputs)
	if (locale === "id") return id_is_community_enabled(inputs)
	if (locale === "it") return it_is_community_enabled(inputs)
	if (locale === "ru") return ru_is_community_enabled(inputs)
	if (locale === "pt") return pt_is_community_enabled(inputs)
	return ko_is_community_enabled(inputs)
});